import Checkbox from '@components/v2/form/Checkbox/Checkbox';
import { Box } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { CombinationLineProps } from '../../types/combinationLine.types';

interface CombinationMassActionCheckboxProps {
  massActionProps?: CombinationLineProps['massActionProps'];
}

const CombinationMassActionCheckbox = ({ massActionProps }: CombinationMassActionCheckboxProps) => {
  const { translate } = useTranslation();

  if (!massActionProps?.showCheckbox) {
    return null;
  }

  return (
    <Box sx={{ flexShrink: 0, paddingRight: 0.5, marginLeft: -0.5 }}>
      <Checkbox
        size="small"
        checked={massActionProps.isChecked}
        disabled={massActionProps.disableCheckbox}
        slotProps={{ input: { 'aria-label': translate(LangEnum.GLOBAL_SELECT_ITEM) } }}
        sx={{ '&.Mui-checked.Mui-disabled': { color: 'accent.main' } }}
        onChange={massActionProps.toggleSelectedItem}
      />
    </Box>
  );
};

export default CombinationMassActionCheckbox;
